var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobLikeFilledBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 8.5C19.0223 8.5 18.3046 8.66943 17.6537 8.99487C17.0028 9.32032 16.4366 9.79283 16 10.375C15.4097 9.58794 14.5867 9.00656 13.6477 8.71322C12.7086 8.41987 11.701 8.42943 10.7677 8.74055C9.83434 9.05166 9.02255 9.64855 8.4473 10.4467C7.87205 11.2448 7.5625 12.2037 7.5625 13.1875C7.5625 18.8047 15.3672 23.2344 15.6953 23.4219C15.7883 23.4741 15.8934 23.5011 16 23.5C16.1067 23.5018 16.212 23.4748 16.3047 23.4219C17.7419 22.5816 19.09 21.5974 20.3281 20.4844C23.0547 18.0312 24.4375 15.5781 24.4375 13.1875C24.4375 11.9443 23.9436 10.752 23.0646 9.87294C22.1855 8.99386 20.9932 8.5 19.75 8.5Z",
    fill: "#DA4167"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobLikeFilledBtn);
export default __webpack_public_path__ + "static/media/mob-like-filled-btn.b578139b8336a3691c03d2574ff5d072.svg";
export { ForwardRef as ReactComponent };